/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    interface IMeevoSelectAndCopyScope extends ng.IScope {
        meevoSelectAndCopy: string; // ID of element to copy
        disableSelectionAfter?: boolean;
    }

    interface IMeevoSelectAndCopyAttrs extends angular.IAttributes {
        meevoSelectAndCopy: string;
        disableSelectionAfter: string;
    }

    class MeevoSelectAndCopy implements angular.IDirective {
        static factory(): angular.IDirectiveFactory {
            let directive = (modalService: Meevo.Components.Modal.IModalService) => {
                return new MeevoSelectAndCopy(modalService);
            };

            directive.$inject = ['meevo.components.modal.ModalService'];

            return directive;
        }

        restrict = 'A';

        scope = {
            meevoSelectAndCopy: '@',
            disableSelectionAfter: '=?'
        };

        constructor(private modalService: Meevo.Components.Modal.IModalService) {
        }

        link(scope: IMeevoSelectAndCopyScope, element: JQuery, attrs: IMeevoSelectAndCopyAttrs) {
            if (typeof attrs.disableSelectionAfter === 'undefined') {
                scope.disableSelectionAfter = true;
            }

            element.on('click', () => {
                //Before we copy, we are going to select the text.
                let text = document.getElementById(scope.meevoSelectAndCopy);
                if (!text) {
                    throw new Error(`Can't find element with id="${scope.meevoSelectAndCopy}"`);
                }

                // make element selectable
                angular.extend(text.style, {
                    '-webkit-user-select': 'text',
                    '-moz-user-select': 'text',
                    '-ms-user-select': 'text',
                    'user-select': 'text'
                });

                let selection = window.getSelection();
                let range = document.createRange();
                range.selectNodeContents(text);
                selection.removeAllRanges();
                selection.addRange(range);
                //add to clipboard.
                document.execCommand('copy');
                selection.removeAllRanges();

                if (scope.disableSelectionAfter) {
                    // return back disable selection functionality
                    angular.extend(text.style, {
                        '-webkit-user-select': 'none',
                        '-moz-user-select': 'none',
                        '-ms-user-select': 'none',
                        'user-select': 'none'
                    });
                }

                this.modalService.alert("NOTIFICATION_COPY_SUCCESS");
            });
        };

    }

    angular.module('meevo.components.controls')
        .directive('meevoSelectAndCopy', MeevoSelectAndCopy.factory());
}